var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-track"},[_c('div',{staticClass:"progress-fill",style:({ width: `${_vm.clampedPercentage}%` }),attrs:{"role":"progressbar","aria-valuenow":_vm.clampedPercentage,"aria-valuemin":"0","aria-valuemax":"100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }